// TODO get SVGs from contentful

export const Trophy = ({ className, color }) => (
  <svg
    className={className}
    width='40px'
    height='40px'
    viewBox='0 0 40 40'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Nominees' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        id='Desktop-Copy'
        transform='translate(-462.000000, -691.000000)'
        fill={color}
        fillRule='nonzero'
      >
        <g id='iconmonstr-trophy-11' transform='translate(462.000000, 691.000000)'>
          <path
            d='M9.37833333,31.7116667 L13.1533333,37.31 C12.0816667,38.0566667 11.1216667,38.9616667 10.3066667,40 L9.50666667,35.8233333 L5,35.8233333 C6.24166667,34.2416667 7.71833333,32.8533333 9.37833333,31.7116667 L9.37833333,31.7116667 Z M30.6216667,31.7116667 L26.8466667,37.31 C27.9183333,38.0566667 28.8783333,38.9616667 29.6933333,40 L30.4933333,35.8233333 L35,35.8233333 C33.7583333,34.2416667 32.2816667,32.8533333 30.6216667,31.7116667 L30.6216667,31.7116667 Z M20,27.7316667 C16.3366667,27.7316667 12.9066667,28.7233333 9.96166667,30.4516667 L13.7466667,36.065 C15.61,35.0533333 17.74,34.485 20,34.485 C22.26,34.485 24.39,35.0516667 26.2533333,36.065 L30.0383333,30.4516667 C27.0933333,28.7233333 23.6633333,27.7316667 20,27.7316667 Z M16.0983333,33.19 L15.2033333,32.7116667 L14.31,33.19 L14.4883333,32.1916667 L13.7583333,31.49 L14.7616667,31.3516667 L15.2033333,30.44 L15.6466667,31.3516667 L16.6516667,31.49 L15.9216667,32.1916667 L16.0983333,33.19 L16.0983333,33.19 Z M21.3466667,32.9983333 L19.9833333,32.2683333 L18.6166667,32.9983333 L18.89,31.4733333 L17.7716667,30.4016667 L19.3066667,30.19 L19.9833333,28.7983333 L20.6583333,30.19 L22.1916667,30.4016667 L21.0733333,31.4733333 L21.3466667,32.9983333 Z M25.6516667,33.19 L24.7583333,32.7116667 L23.865,33.19 L24.0416667,32.1916667 L23.3116667,31.49 L24.3166667,31.3516667 L24.76,30.44 L25.2016667,31.3516667 L26.2066667,31.49 L25.4766667,32.1916667 L25.6516667,33.19 Z M30.015,16.0933333 C29.5383333,17.1566667 29.04,18.145 28.545,19.065 C35.32,16.8183333 39.38,10.175 40,3.33333333 L33.205,3.33333333 C33.145,4.13666667 33.0716667,4.925 32.9733333,5.675 L37.4533333,5.675 C36.7433333,9.01 34.8733333,13.5566667 30.015,16.0933333 Z M20,26.065 C20.9616667,26.065 21.92,26.13 22.8683333,26.2566667 C24.9033333,20.4766667 31.6666667,14.5983333 31.6666667,5.92118946e-15 L8.33333333,5.92118946e-15 C8.33333333,14.5966667 15.1083333,20.475 17.15,26.2533333 C18.09,26.1283333 19.0433333,26.065 20,26.065 Z M15.0816667,3.33333333 C15.1,9.36833333 16.3483333,16.3216667 19.4916667,21.755 C15.5666667,17.2216667 12.5916667,11.08 12.25,3.33333333 L15.0816667,3.33333333 L15.0816667,3.33333333 Z M11.455,19.0633333 C10.96,18.1433333 10.4616667,17.155 9.985,16.0916667 C5.12666667,13.5566667 3.25666667,9.00833333 2.545,5.67333333 L7.025,5.67333333 C6.92833333,4.925 6.855,4.13666667 6.795,3.33333333 L0,3.33333333 C0.62,10.175 4.68,16.8183333 11.455,19.0633333 L11.455,19.0633333 Z'
            id='Shape'
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

export const Medal = ({ className, color }) => (
  <svg
    className={className}
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    width='40px'
    height='40px'
    viewBox='0 0 40 40'
  >
    <g id='Nominees'>
      <g id='Desktop-Copy' transform='translate(-870.000000, -691.000000)'>
        <g id='iconmonstr-award-2' transform='translate(870.000000, 691.000000)'>
          <path
            fill={color}
            id='Shape'
            className='st0'
            d='M31.9,8.8c-0.8,2.4-0.8,2,0,4.4C32,13.4,32,13.7,32,14c0,0.8-0.4,1.5-1.1,2
          c-2.2,1.5-1.9,1.1-2.7,3.5c-0.3,1-1.3,1.7-2.4,1.7h0c-2.7,0-2.2-0.2-4.3,1.4c-0.4,0.3-1,0.5-1.5,0.5s-1.1-0.2-1.5-0.5
          c-2.1-1.5-1.7-1.4-4.3-1.4h0c-1.1,0-2.1-0.7-2.4-1.7c-0.8-2.4-0.5-2.1-2.7-3.5C8.4,15.5,8,14.7,8,14c0-0.3,0-0.5,0.1-0.8
          c0.8-2.4,0.8-2,0-4.4C8,8.6,8,8.3,8,8c0-0.8,0.4-1.5,1.1-2c2.1-1.5,1.9-1.1,2.7-3.5c0.3-1,1.3-1.7,2.4-1.7h0
          c2.6,0,2.2,0.2,4.3-1.4C18.9-0.8,19.5-1,20-1s1.1,0.2,1.5,0.5c2.1,1.5,1.7,1.4,4.3,1.4h0c1.1,0,2.1,0.7,2.4,1.7
          c0.8,2.4,0.5,2.1,2.7,3.5C31.6,6.5,32,7.3,32,8C32,8.3,32,8.6,31.9,8.8z M26.9,11c0-3.8-3.1-6.9-6.9-6.9s-6.9,3.1-6.9,6.9
          s3.1,6.9,6.9,6.9S26.9,14.8,26.9,11z M20,26.4c-2,0-2.9-0.7-4.3-1.7h-2.5v15.4l6.9-5.1l6.8,5.1V24.7h-2.6
          C23.2,25.7,21.7,26.4,20,26.4z'
          />
        </g>
      </g>
    </g>
  </svg>
)
